<template>
    <div class="patternContainer">
        <div v-show="!loaded" ref="progress" class="Loading">
            <div class="loader"></div>
            <h3>Carregando Modelo</h3>
        </div>
        <ControlContainer
            v-if="loaded"
            :renderer="renderer"
            :render-window="renderWindow"
            :mappers="mappers"
        />
        <div ref="vtkContainer" class="container" />
    </div>
</template>

<script>
import "@kitware/vtk.js/Rendering/Profiles/Geometry";
import vtkRenderWindow from "@kitware/vtk.js/Rendering/Core/RenderWindow";
import vtkOpenGLRenderWindow from "@kitware/vtk.js/Rendering/OpenGL/RenderWindow";
import macro from "@kitware/vtk.js/macros";
import vtkRenderWindowInteractor from "@kitware/vtk.js/Rendering/Core/RenderWindowInteractor";
import vtkColorTransferFunction from "@kitware/vtk.js/Rendering/Core/ColorTransferFunction";
import HttpDataAccessHelper from "@kitware/vtk.js/IO/Core/DataAccessHelper/HttpDataAccessHelper";
import vtkXMLPolyDataReader from "@kitware/vtk.js/IO/XML/XMLPolyDataReader";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import ControlContainer from "./ControlContainer/controlContainer";
import vtkRenderer from "@kitware/vtk.js/Rendering/Core/Renderer";
import vtkInteractorStyleTrackballCamera from "@kitware/vtk.js/Interaction/Style/InteractorStyleTrackballCamera";
export default {
    name: "VtkGeometry",
    components: { ControlContainer },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        objs: {
            type: Array,
            require: true
        }
    },
    data() {
        return {
            ready: false,
            mappers: [],
            message: "Hello",
            loaded: false,
            percent: 0,
            percents: [0],
            renderer: null,
            renderWindow: null
        };
    },
    mounted() {
        this.renderWindow = vtkRenderWindow.newInstance();
        this.renderer = vtkRenderer.newInstance({ background: [0, 0, 0] });
        this.renderWindow.addRenderer(this.renderer);
        this.renderer.resetCamera();
        const openGLRenderWindow = vtkOpenGLRenderWindow.newInstance();
        this.renderWindow.addView(openGLRenderWindow);
        openGLRenderWindow.setContainer(this.$refs.vtkContainer);
        const {
            width,
            height
        } = this.$refs.vtkContainer.getBoundingClientRect();
        openGLRenderWindow.setSize(width, height);
        const interactor = vtkRenderWindowInteractor.newInstance();
        interactor.setView(openGLRenderWindow);
        interactor.initialize();
        interactor.bindEvents(this.$refs.vtkContainer);
        interactor.setInteractorStyle(
            vtkInteractorStyleTrackballCamera.newInstance()
        );
        this.lookupTable = vtkColorTransferFunction.newInstance();
        const before = Date.now();
        Promise.all(
            this.objs.map(async ({ url, name }, i) => {
                return await this.loadContentAsync(url, name, i);
            })
        ).then(() => {
            this.render();
            const after = Date.now();
            console.log((after - before) / 1000);
        });
    },
    methods: {
        calcPercent() {
            this.percent = Math.floor(
                this.percents.reduce((p, c) => p + c) / this.percents.length
            );
        },
        progressCallback(index) {
            if (this.percents.length < index + 1) this.percents.push(0);
            return progressEvent => {
                if (progressEvent.lengthComputable) {
                    this.percents[index] = Math.floor(
                        (100 * progressEvent.loaded) / progressEvent.total
                    );
                    this.calcPercent();
                    return;
                }
                this.percents[index] = macro.formatBytesToProperUnit(
                    progressEvent.loaded
                );
                this.calcPercent();
            };
        },
        render() {
            this.renderer.resetCamera();
            this.renderWindow.render();
            this.loaded = true;
        },
        async loadContentAsync(url, name, index) {
            const lookupTable = vtkColorTransferFunction.newInstance();
            const vtpReader = vtkXMLPolyDataReader.newInstance();
            await vtpReader.setUrl(url);
            const mapper = vtkMapper.newInstance({
                interpolateScalarsBeforeMapping: false,
                useLookupTableScalarRange: true,
                lookupTable: lookupTable,
                scalarVisibility: false
            });
            const actor = vtkActor.newInstance();
            actor.setMapper(mapper);
            mapper.setInputConnection(vtpReader.getOutputPort());
            this.renderer.addActor(actor);
            this.mappers.push({
                mapper,
                name,
                actor,
                lookupTable
            });
        }
    }
};
</script>

<style scoped>
.Loading {
    position: absolute;
    z-index: 2;
    color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    gap: 15px;
}

.controls {
    position: absolute;
    top: 25px;
    left: 25px;
    background: black;
    padding: 12px;
}

.container {
    max-height: 100%;
    height: 100%;
    max-width: 100%;
    padding: 0;
}

.patternContainer {
    position: relative;
    width: 100%;
}

.loader {
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #3498db;
    width: 35px;
    height: 35px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
